import { getTracer, otelContext, otelTrace } from '@thoughtspot/observability';
export { otelContext, otelTrace };
const NOOP_SPAN = {
    setAttribute: () => NOOP_SPAN,
    setAttributes: () => NOOP_SPAN,
    addEvent: () => NOOP_SPAN,
    setStatus: () => NOOP_SPAN,
    updateName: () => NOOP_SPAN,
    end: () => { },
    isRecording: () => false,
    recordException: () => { },
    spanContext: () => ({ traceId: '', spanId: '', traceFlags: 0 }),
};
export function startSpan(op, parentCtx, enabled, attributes = {}) {
    if (!enabled || !parentCtx)
        return NOOP_SPAN;
    try {
        return getTracer('ts-chart-app').startSpan(op.name, {
            attributes: {
                'span.description': op.description,
                ...attributes,
            },
        }, parentCtx);
    }
    catch {
        return NOOP_SPAN;
    }
}
export function childContext(parentCtx, span) {
    if (!parentCtx || !span?.isRecording?.())
        return parentCtx;
    return otelTrace.setSpan(parentCtx, span);
}
export function createFinishedSpan(name, startMs, endMs, parentCtx, attributes = {}) {
    try {
        const span = getTracer('valkyrie-charts-iframe').startSpan(name, { startTime: startMs, attributes }, parentCtx);
        const childCtx = otelTrace.setSpan(parentCtx, span);
        span.end(endMs);
        return childCtx;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=tracer.js.map